import React from 'react';
import CuadroListaEditable from '../../edicion/CuadroListaEditable.js';
import * as Data from '../../edicion/data/DataTorneoSedes.js';
import * as DTOs from '../../edicion/DTOs/TorneoSedesDTOs.js';
import * as Funciones from '../../edicion/funciones/FuncionesTorneoSedes.js';

const SedesTorneo = (props) => {
  const idTorneo = props.datosElegidos?.torneo?.id;

  return (
    <CuadroListaEditable
      titulo="Sedes"
      idPadre={idTorneo}
      data={Data}
      dtos={DTOs}
      funciones={Funciones}
    />
  );
};

export default SedesTorneo;
